export default (state= [], action) => {
    switch (action.type){
        case 'FETCH_MARKETSWHEEL':
            return action.payload
           
        default:
            return state;
    }
};